import client from './index'

export default {
    /**
     * 대용량 첨부 템플릿을 가져옵니다.
     * @param {string} code 대용량 첨부 그룹 코드
     * @returns template html string
     */
    deleteFiles: function (mode: string, code: string, codeValues: string[], fileNames: string[], identifiers: string[]): Promise<string> {
        return client.post({
            url: '/file/store/api/delete',
            data: {
                mode: mode,
                code: code,
                codeValues: codeValues,
                fileNames: fileNames,
                fileIdentifiers: identifiers
            },
        })
    }
}
